import React, { useState, useEffect, useRef } from 'react';
import { Modal, Form, Button, message } from 'antd';
import { InfoBox, Input, SelectFile } from 'components';
import { addNumbersToBlacklist, addOptOut } from 'services/blacklist.service';
import { customMessages, customValidators } from 'utils';
import NewContact from 'assests/icons/new-contact.icon';
import ImportExcelIcon from 'assests/icons/import-excel.icon';
import DownChevronIcon from 'assests/icons/down-chevron.icon';
import UploadIcon from 'assests/icons/upload.icon';

const AddFileModal = (props) => {
  const [form] = Form.useForm();
  const [importFileModal, setImportFileModal] = useState(false);
  const [isFileSelected, setIsFileSelected] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [fileList, setFileList] = useState([]);
  const selectFileRef = useRef(null);

  function onCloseFileUploadModal() {
    setImportFileModal(false);
    setIsFileSelected(false);
  }

  const onFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setIsFileSelected(true);
      setUploadedFile(file);
    }
  };

  function addContactsToBlackList() {
    addNumbersToBlacklist(uploadedFile)
      .then((res) => {
        setImportFileModal(false);
        props.onSuccess();
        form.resetFields();
      })
      .catch((response) => {
        Modal.error({
          title: 'Hata',
          content: customMessages.getMessage(response.responseCode),
        });
      });
  }

  return (
    <React.Fragment>
      <div>
        <input
          type="file"
          ref={selectFileRef}
          onChange={(e) => {
            setFileList(e.target.files);
          }}
        />
        <button type="button" onClick={() => setImportFileModal(true)}>
          <ImportExcelIcon />
          İçe Aktar
          <DownChevronIcon />
        </button>
      </div>
      <Modal
        title="Dosyayı İçeri Aktar"
        visible={importFileModal}
        onCancel={() => setImportFileModal(false)}
        footer={null}
      >
        <Form form={form} name="import-file">
          <InfoBox
            type="warning"
            content={
              <p>
                Eğer Excel yüklerken sorun yaşıyorsanız düzgün formatı{' '}
                <a href="/samples/ornekKaraliste.xlsx" download>
                  buradan
                </a>{' '}
                indirebilirsiniz.
              </p>
            }
          />
          <Form.Item name="select-file" messageVariables={{ label: 'file' }}>
            <SelectFile
              onChange={onFileUpload}
              uploaderRef={selectFileRef}
              type="file"
              fileList={fileList}
              title={<span>Excel'den İçe Aktar</span>}
              icon={<UploadIcon />}
            />
          </Form.Item>
          <div className="modal-action">
            <Button
              shape="round"
              type="ghost"
              onClick={() => {
                onCloseFileUploadModal();
              }}
            >
              Vazgeç
            </Button>
            <Button
              disabled={!isFileSelected}
              key="confirm"
              type="primary"
              onClick={() => addContactsToBlackList()}
            >
              Kaydet
            </Button>
          </div>
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default AddFileModal;
